import React, { FC } from "react";
import { graphql } from "gatsby";

import Header from "../partials/Header";
import BlogList from "../partials/BlogList";
import Newsletter from "../partials/Newsletter";
import Footer from "../partials/Footer";
import Seo from "../partials/Seo";

const Blog: FC<any> = ({ data }) => (
  <>
    <Seo title="Blog" />

    <div className="flex flex-col min-h-screen overflow-hidden">
      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">
        {/*  Page sections */}
        <BlogList posts={data.allMediumFeed.nodes} />
        <Newsletter />
      </main>

      {/*  Site footer */}
      <Footer />
    </div>
  </>
);

export default Blog;

export const pageQuery = graphql`
  query {
    allMediumFeed(limit: 13) {
      nodes {
        id
        slug
        title
        description
        thumbnail
        date(formatString: "MMM YYYY")
        link
        tags {
          slug
          name
        }
      }
    }
  }
`;
